import { useRef } from 'react';

type Callback = (...args: unknown[]) => unknown;

export const useExecutionTimer = (startFn: Callback, cleanFn: Callback, delayTime: number) => {
  const startTimer = useRef<NodeJS.Timeout>();
  const closeTimer = useRef<NodeJS.Timeout>();

  const startFunction: Callback = (...args) => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    startTimer.current = setTimeout(() => startFn(...args), delayTime);
  };

  const cleanFunction: Callback = (...args) => {
    if (startTimer.current) clearTimeout(startTimer.current);
    closeTimer.current = setTimeout(() => cleanFn(...args), 30);
  };
  return [startFunction, cleanFunction];
};

export default useExecutionTimer;
